import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Button, Form, Input, Checkbox, Modal } from "antd";
import { unAuthenticatedRoutes } from "../../routes/constant";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { CameraFilled } from "@ant-design/icons";
// import AuthService from "../../services/auth.service";
import AuthServiceV2 from "../../servicesV2/authV2.service";
import notificationService from "../../util/notification.service";
import utilService from "../../util/utils.service";
import profilePlaceholder from "../../assets/images/Profile-placeholder.svg";
import businessPlaceholder from "../../assets/images/businessPlaceholder.svg";
import mailPlaceholder from "../../assets/images/mail.svg";
// import addPhoto from "../../assets/images/addphoto.svg";
import ImageUploader from "../../components/ImagesUpload/ImagesUpload";
import { PASSWORD_REGEX } from "../../util/app.constant";
import "./vendor.Register.less";

const FormItem = Form.Item;

const Register = (props) => {
    // const inputRef = useRef(null);
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fileListConverted, setFileListConverted] = useState([]);
    const [place, setPlace] = useState();
    const autoCompleteRef = useRef();
    const inputRef = useRef();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const options = {
        fields: [
            "address_components",
            "geometry",
            "icon",
            "name",
            "formatted_address",
        ],
        types: ["establishment"],
    };

    useEffect(() => {
        autoCompleteRef.current = new window.google.maps.places.Autocomplete(
            inputRef.current,
            options
        );
        autoCompleteRef.current.addListener("place_changed", async function () {
            const place = await autoCompleteRef.current.getPlace();
            setPlace(place);
            let countryName = "";
            let cityName = "";
            let countryISOCode = "";
            place.address_components.map((item, index) => {
                if (item?.types[0] == "country") {
                    countryName = item["long_name"];
                    countryISOCode = item["short_name"];
                }
                if (item?.types[0] == "locality") {
                    cityName = item["long_name"];
                }
                form.setFieldsValue({
                    country: countryName,
                    city: cityName,
                    countryISOCode: countryISOCode,
                    location: place.formatted_address,
                });
            });
        });
    }, []);

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    const validatePassword = (_, value) => {
        const passwordRegex = PASSWORD_REGEX;

        if (!value) {
            return Promise.reject();
        }
        if (/\s/.test(value)) {
            return Promise.reject("Password must not contain spaces");
        }

        if (value.length < 6) {
            return Promise.reject(
                "Password must be at least 6 characters long"
            );
        }

        if (!passwordRegex.test(value)) {
            return Promise.reject(
                "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 digit and 1 special character"
            );
        }

        return Promise.resolve();
    };

    const onFinish = async (values) => {
        setLoading(true);

        let countryName = "";
        let cityName = "";
        let countryISOCode = "";

        if (place != null) {
            place.address_components.map((item, index) => {
                if (item?.types[0] == "country") {
                    values.country = item["long_name"];
                    countryName = item["long_name"];
                    countryISOCode = item["short_name"];
                }
                if (item?.types[0] == "locality") {
                    values.city = item["long_name"];
                    cityName = item["long_name"];
                }
            });
        } else {
            notificationService.error("Please select a valid address.");
            // Form.setFields([
            //     {
            //         name: "location",
            //         errors: ["Please select a valid address!"],
            //     },
            // ]);
            setLoading(false);
            return;
        }

        // values.location = place.address_components[0]["long_name"];
        // values.location += " " + place.address_components[1]["long_name"];
        // values.location += " " + place.address_components[2]["long_name"];

        // values.location =
        //     (place?.address_components[0]?.long_name || "") +
        //     " " +
        //     (place?.address_components[1]?.long_name || "") +
        //     " " +
        //     (place?.address_components[2]?.long_name || "");

        values.location = place?.formatted_address;

        const formData = new FormData();
        formData.append("username", values.username);
        formData.append("bussiness_name", values.business_name);
        formData.append("password", values.password);
        formData.append("confirmPassword", values.confirmPassword);
        formData.append("email", values.email);
        formData.append("location", values.location);
        if (cityName) {
            formData.append("city", cityName);
        }
        if (countryName) {
            formData.append("country", countryName);
            formData.append("countryISOCode", countryISOCode);
        }

        if (fileList.length > 0) {
            for (const file of fileList) {
                formData.append("file", file.originFileObj);
            }
        }

        const payload = formData;

        const { ok, data } = await AuthServiceV2.register(payload);

        if (ok) {
            notificationService.success(`Registration Successful`);
            setTimeout(() => {
                return utilService.redirectTo(unAuthenticatedRoutes.LOGIN);
            }, 3000);
        } else {
            notificationService.error(data?.message);
        }
        setLoading(false);
    };
    // const UploadCompanyLogo = () => {
    //     // if (inputRef?.current && inputRef?.current?.files) {
    //     //     const formData = new FormData();
    //     //     formData.append("Picture", inputRef?.current?.files[0]);
    //     //     uploadImage(formData);
    //     // }
    // };
    return (
        <Row
            className="register-wrap auth-background reset-pass-main gx-pt-5"
            justify={"center"}
            align={"middle"}
        >
            <Col lg={10} xl={10} xxl={10} md={20}>
                <Row gutter={[0, 25]} type="flex">
                    <Col
                        span={24}
                        className="gx-mb-2"
                        align="middle"
                        justify="center"
                    >
                        <div className="gx-app-logo">
                            <p>GET STARTED</p>
                            <h2>Create Your Account</h2>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div className="gx-app-login-main-content">
                            <div className="gx-app-login-content">
                                <Form
                                    form={form}
                                    initialValues={{ remember: true }}
                                    name="basic"
                                    onFinish={onFinish}
                                    className="gx-signin-form gx-form-row0"
                                >
                                    <Form.Item
                                        name="username"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Username is required",
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            placeholder="Username"
                                            suffix={
                                                <img
                                                    src={profilePlaceholder}
                                                    alt="Username"
                                                />
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="business_name"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Business Name is required",
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            placeholder="Business Name"
                                            suffix={
                                                <img
                                                    src={businessPlaceholder}
                                                    alt="Business Name"
                                                />
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Email is required",
                                            },
                                            {
                                                type: "email",
                                                message:
                                                    "The input is not valid E-mail!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            placeholder="Business Email"
                                            suffix={
                                                <img
                                                    src={mailPlaceholder}
                                                    alt="Email"
                                                />
                                            }
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="location"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Address is Required",
                                            },
                                        ]}
                                    >
                                        <span className="inpt">
                                            <input
                                                name="address"
                                                placeholder="Address"
                                                className="inpt"
                                                suffix={
                                                    <img
                                                        src={mailPlaceholder}
                                                        alt="Email"
                                                    />
                                                }
                                                ref={inputRef}
                                            />
                                        </span>
                                    </Form.Item>
                                    <Form.Item
                                        className="inpt"
                                        name="city"
                                        style={{
                                            borderRadius: "5px",
                                            paddingLeft: "0",
                                        }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "City is Required",
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            placeholder="City"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="country"
                                        className="inpt"
                                        style={{
                                            borderRadius: "5px",
                                            paddingLeft: "0",
                                        }}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Country is Required",
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            placeholder="Country"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input your password!",
                                            },
                                            { validator: validatePassword },
                                        ]}
                                        // hasFeedback
                                    >
                                        <Input.Password
                                            className="inpt"
                                            placeholder="Password"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="confirmPassword"
                                        dependencies={["password"]}
                                        // hasFeedback
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please confirm your password!",
                                            },
                                            // { validator: validatePassword },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (
                                                        !value ||
                                                        getFieldValue(
                                                            "password"
                                                        ) === value
                                                    ) {
                                                        return Promise.resolve();
                                                    }

                                                    return Promise.reject(
                                                        new Error(
                                                            "The two passwords that you entered do not match!"
                                                        )
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password
                                            className="inpt"
                                            placeholder="Confirm Password"
                                        />
                                    </Form.Item>
                                    {/* <FormItem className="register-company-logo-container">
                                        <Row>
                                            <Col
                                                onClick={() =>
                                                    inputRef.current.click()
                                                }
                                                align="middle"
                                                className="register-company-logo-btn"
                                            >
                                                <img
                                                    src={addPhoto}
                                                    className="gx-mr-3 gx-mb-1"
                                                    alt="Registered Company"
                                                />
                                                Upload Company Logo
                                            </Col>
                                        </Row>
                                    </FormItem>
                                    <input
                                        onChange={UploadCompanyLogo}
                                        type="file"
                                        style={{ display: "none" }}
                                        ref={inputRef}
                                    /> */}

                                    <Form.Item
                                        className="register-company-logo-container"
                                        name="profileImage"
                                        valuePropName="fileList"
                                        getValueFromEvent={normFile}
                                    >
                                        <ImageUploader
                                            supportedFormats={[
                                                "image/jpg",
                                                "image/jpeg",
                                                "image/png",
                                            ]}
                                            listType="picture"
                                            accept="image/png,image/jpeg,image/jpg"
                                            maxCount={1}
                                            onChange={(fileList) => {
                                                setFileList(fileList);
                                            }}
                                            filePreviewCallback={(
                                                previewImageObjects
                                            ) => {
                                                setFileListConverted(
                                                    previewImageObjects
                                                );
                                            }}
                                            showUploadList={false}
                                            maxFileSize={100}
                                            isCustomPreview={false}
                                        >
                                            <Button type="primary">
                                                <CameraFilled /> Upload Company
                                                Logo
                                            </Button>
                                        </ImageUploader>
                                    </Form.Item>
                                    <Form.Item
                                        name="termsOfService"
                                        valuePropName="checked"
                                        rules={[
                                            {
                                                validator: (_, value) =>
                                                    value
                                                        ? Promise.resolve()
                                                        : Promise.reject(
                                                              new Error(
                                                                  "Should accept agreement"
                                                              )
                                                          ),
                                            },
                                        ]}
                                    >
                                        <Checkbox type="checkbox">
                                            I agree to Glee's
                                            <a onClick={showModal}>
                                                Onboarding software contact
                                            </a>
                                            . I acknowledge that I have read and
                                            understood the onboarding software
                                            contact and agree to its terms.
                                        </Checkbox>
                                    </Form.Item>
                                    <Modal
                                        title="Terms & Conditions"
                                        open={isModalOpen}
                                        onOk={handleOk}
                                        onCancel={handleCancel}
                                        footer=""
                                        centered
                                        bodyStyle={{ height: "90vh" }}
                                        // footer={[
                                        //     <Button
                                        //         className=" butn"
                                        //         type="primary"
                                        //         key="back"
                                        //         onClick={handleCancel}
                                        //     >
                                        //         Return
                                        //     </Button>,
                                        //     <Button
                                        //         className=" butn"
                                        //         type="primary"
                                        //         key="submit"
                                        //         loading={loading}
                                        //         onClick={handleOk}
                                        //     >
                                        //         Submit
                                        //     </Button>,
                                        // ]}
                                        width={1000}
                                    >
                                        <iframe
                                            width="100%"
                                            height="100%"
                                            src={
                                                "https://glee-assets.s3.amazonaws.com/onboarding-contract.pdf"
                                            }
                                            alt="terms and conditions"
                                            style={{
                                                width: "100%",
                                            }}
                                        />
                                    </Modal>

                                    <FormItem>
                                        <Button
                                            type="primary"
                                            className="gx-mt-4 butn"
                                            htmlType="submit"
                                            loading={loading}
                                        >
                                            Register
                                        </Button>
                                    </FormItem>
                                    <Row justify={"center"}>
                                        <Col>
                                            <p>
                                                Already have an account?{" "}
                                                <Link
                                                    style={{
                                                        color: `#FB8762`,
                                                    }}
                                                    to="/login"
                                                    // className="noirProMedium mediumLine"
                                                >
                                                    Sign in
                                                </Link>
                                            </p>
                                        </Col>
                                    </Row>

                                    <Row justify={"center"}>
                                        <Col>
                                            <p>
                                                <Link
                                                    style={{
                                                        color: `#FB8762`,
                                                    }}
                                                    to="/privacy-policy"
                                                >
                                                    Privacy Policy
                                                </Link>
                                            </p>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default Register;
